// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__W9jQo","signatureButtonsRight":"ModalSign_signatureButtonsRight__3Ub9V"};